import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiFetch } from "@core/index";
import { apiEndpoint } from "../utils/constants";
import { PublishersPayload } from "../utils/types";

export const useCreatePublisher = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: { payload: PublishersPayload }) => {
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}`, {
        method: "POST",
        body: config.payload,
      });
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message || "", {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Publisher created successfully.", {
          variant: "success",
          autoHideDuration: 2000,
        });
        queryClient.invalidateQueries({ queryKey: ["publishers"] });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to create a new publisher. Error: " + (error.message ?? ""),
        {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        },
      );
    },
  });
};
